import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=024a6c08&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"
import style0 from "./NavBar.vue?vue&type=style&index=0&id=024a6c08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024a6c08",
  null
  
)

export default component.exports